import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { AIChatBox, type Message as ChatMessage } from "@/components/AIChatBox";

export default function HomeSupportSection() {
  const [chatMessages, setChatMessages] = useState<ChatMessage[]>([]);
  const chatMutation = trpc.supportSimulation.publicChat.useMutation({
    onSuccess: (result) => setChatMessages((current) => [...current, { role: "assistant", content: result.draft }]),
    onError: () => setChatMessages((current) => [...current, { role: "assistant", content: "Thanks for contacting support. A human support specialist needs to review this request." }]),
  });

  return (
    <section className="border-y border-blue-100 bg-blue-50/40 px-4 py-14 md:py-20" data-track-block="support-chat">
      <div className="mx-auto grid max-w-6xl items-center gap-8 lg:grid-cols-[0.8fr_1.2fr]">
        <div>
          <div className="mb-4 flex items-center gap-3 text-blue-700"><MessageCircle className="h-6 w-6" /><span className="text-sm font-semibold uppercase tracking-[0.18em]">IGET support assistant</span></div>
          <h2 className="text-3xl font-bold text-gray-900 md:text-4xl">Ask a clearer IGET question</h2>
          <p className="mt-4 text-base leading-7 text-gray-600">Ask about published IGET information, authenticity notices, the product directory, or Australian support resources. You can type or use the voice button. This assistant does not sell products, take orders, provide medical advice, or replace human support.</p>
        </div>
        <AIChatBox messages={chatMessages} onSendMessage={(text) => { setChatMessages((current) => [...current, { role: "user", content: text }]); chatMutation.mutate({ text }); }} isLoading={chatMutation.isPending} height="420px" placeholder="Type an English support question..." emptyStateMessage="Ask a non-transactional IGET support question" suggestedPrompts={["How do I find an Australian retailer?", "How can I check an IGET product may be counterfeit?"]} />
      </div>
    </section>
  );
}
